import {
	initializeAppCheck,
	ReCaptchaV3Provider,
	getToken,
	AppCheck,
} from 'firebase/app-check';
import { app } from './firebaseConfig';
import { APP_CHECK_SITE_KEY } from './config';

let appCheckInstance: AppCheck | undefined;

export function initAppCheck() {
	if (appCheckInstance || !APP_CHECK_SITE_KEY) return;

	try {
		appCheckInstance = initializeAppCheck(app, {
			provider: new ReCaptchaV3Provider(APP_CHECK_SITE_KEY),
			isTokenAutoRefreshEnabled: true,
		});
	} catch (error) {
		console.error('Error initializing AppCheck', error);
	}
}

let tokenPromise: Promise<string | null> | null = null;

export function getAppCheckToken(): Promise<string | null> {
	if (tokenPromise) return tokenPromise;

	tokenPromise = (async () => {
		try {
			if (!appCheckInstance) initAppCheck();
			if (!appCheckInstance) return null;

			const result = await getToken(appCheckInstance);

			return result.token;
		} catch {
			return null;
		} finally {
			tokenPromise = null;
		}
	})();

	return tokenPromise;
}
